import { computed, observable } from 'mobx';
import {UIHeroGenre, UIHeroTheme, UIHeroTempo, UIBrowseSection} from '../../types/ui';
import {OnboardingSignUpModalProps} from '../../components/onboarding-sign-up-modal';

export class ContentModel {
  @observable fetched: boolean = false;

  @observable seo: {
    titleFallback: string;
    titleSuffix: string;
    descriptionFallback: string;
    paths: {
      [path: string]: {
        title: string;
        description: string;
        noSuffix: boolean;
      }
    }
  };

  @observable genericOops: Array<any>;

  // TODO refactor these away when as comes from ES now
  @observable genres: Array<UIHeroGenre>;
  @observable themes: Array<UIHeroTheme>;
  @observable tempos: Array<UIHeroTempo>;

  @observable chartingTracks: Array<string>;

  @observable question3Active: boolean;

  @observable cookieNotificationTitle: string;
  @observable cookieNotificationContent: any;

  @observable signUpModalTitle: string;
  @observable signUpModalJaackMaateTitle: string;
  @observable signUpModalVidsummitTitle: string;
  @observable signUpModalBlogosphereTitle: string;
  @observable signUpModalVidconTitle: string;
  @observable signUpModalGoogle: string;
  @observable signUpModalBenefit1: string;
  @observable signUpModalBenefit2: string;
  @observable signUpModalBenefit3: string;
  @observable signUpModalBenefit4: string;
  @observable signUpModalBlurb1: string;
  @observable signUpModalBlurb2: string;
  @observable signUpModalBlurb3: string;
  @observable signUpModalBlurb4: string;

  @computed
  get signUpModalI18n(): OnboardingSignUpModalProps['i18n'] {
    return {
      title: this.signUpModalTitle,
      jaackMaateTitle: this.signUpModalJaackMaateTitle,
      vidsummitTitle: this.signUpModalVidsummitTitle,
      blogosphereTitle: this.signUpModalBlogosphereTitle,
      vidconTitle: this.signUpModalVidconTitle,
      google: this.signUpModalGoogle,
      benefits: [
        {
          heading: this.signUpModalBenefit1,
          content: this.signUpModalBlurb1,
        },
        {
          heading: this.signUpModalBenefit2,
          content: this.signUpModalBlurb2,
        },
        {
          heading: this.signUpModalBenefit3,
          content: this.signUpModalBlurb3,
        },
        {
          heading: this.signUpModalBenefit4,
          content: this.signUpModalBlurb4
        },
      ],
      termsConditions: 'Terms & conditons',
      privacyPolicy: 'Privacy policy'
    }
  }

  @observable licensesDownloadAudio: string;
  @observable licensesDownloadEula: string;
  @observable licensesPreparingEula: string;
  @observable licensesAttribution: string;
  @observable licensesViewOrder: string;
  @observable licensesEmpty: string;

  @computed
  get accountLicensesI18n() {
    return {
      downloadAudio: this.licensesDownloadAudio,
      downloadEULA: this.licensesDownloadEula,
      preparingEULA: this.licensesPreparingEula,
      attribution: this.licensesAttribution,
      viewOrder: this.licensesViewOrder,
      empty: this.licensesEmpty
    }
  }

  @observable shuntCTA: any;
  @observable buttonCTANewUser: string;

  @observable toasts: {[key: string]: {
    key: string;
    title: string;
    message: string;
  }};

  @observable coupons: {[type: string]: {
    type: string;
    title: string;
    message: string;
  }};

  @computed
  get firstUseCoupon(): {
    type: string;
    title: string;
    message: string;
  } {
    return this.coupons && this.coupons['first_use']
      ? this.coupons['first_use']
      : null
  }

  @observable footerBlurb: string;

  @observable strapBrowse: string;
  @observable strapArtist: string;
  @observable strapRelease: string;
  @observable strapTrack: string;
  @observable brandedTrackMessage: string;

  @observable benefits1Title: string;
  @observable benefits1Content: any;
  @observable benefits2Title: string;
  @observable benefits2Content: any;
  @observable benefits3Title: string;
  @observable benefits3Content: any;

  @computed get benefits() {
    return [
      {
        title: this.benefits1Title,
        content: this.benefits1Content,
      },
      {
        title: this.benefits2Title,
        content: this.benefits2Content,
      },
      {
        title: this.benefits3Title,
        content: this.benefits3Content,
      }
    ]
  }

  @observable brandedContentWarning: string;

  @observable downloadModalTitle: string;
  @observable downloadModalStrap: string;
  @observable downloadModalAgree: string;

  @observable addChannelStrap: string;

  @observable licenceModalTitle: string;
  @observable licenceModalLoading: string;
  @observable licenceModalStrap: string;
  @observable licenceModalNotAvailable: string;
  @observable licenceModalClose: string;

  @observable referralTitle: string;
  @observable referralContent: any;
  @observable referralCTA: string;

  @observable ageWarning: string;

  @observable deleteModalContent: any;

  @observable attributionBlurb: string;
  @observable attributionWhy: string;
  @observable attributionContent: string;

  @observable homepageFirstTitle: string;
  @observable homepageFirstCarousel: string;

  @observable homepageSecondTitle: string;
  @observable homepageSecondCarousel: string;

  @observable homepageThirdCarouselTitle: string;
  @observable homepageThirdCarousel: string;

  @observable homepageFourthCarouselTitle: string;
  @observable homepageFourthCarousel: string;

  @observable homepageFifthCarouselTitle: string;
  @observable homepageFifthCarousel: string;

  @observable homepageSixthCarouselTitle: string;
  @observable homepageSixthCarousel: string;

  @observable homepageSeventhCarouselTitle: string;
  @observable homepageSeventhCarousel: string;

  @observable browseBottomGridTitle: string;
  @observable browseBottomGridRightsholder: string;

  @observable browseSections: UIBrowseSection[] = [];
  @observable apiContent: ApiContentData;

  @observable pricingBackground: string;
}

export type ApiContentData = {
  genre: ApiContentDataResults;
  theme: ApiContentDataResults;
}

export type ApiContentDataResults = {
  results: Array<ApiContentDataItem>;
};

export type ApiContentDataItem = {
  name: string;
  slug: string;
  images: {
    identity: string;
  }
}